import { privateApi } from "../../api";

const createNewUser = async (data) => {
    return await privateApi.post('users/createUser', data);
};

export default {
    createNewUser
};